export default {
  noCache() {
    var date = new Date();
    var date_str = date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2) + ("0" + date.getDate()).slice(-2) + ("0" + date.getHours()).slice(-2) + ("0" + date.getMinutes()).slice(-2) + ("0" + date.getSeconds()).slice(-2);
    var nocache_resp = date_str + (Math.floor(Math.random() * 99999999).toString());
    return 'nocache=' + nocache_resp;
  },

  calculateLangUrl: function (arg_outputs, arg_cul_lang, arg_def_lang, arg_streamindex = null) {
    let curOutput = null;
    let curOutputIndex = null;
    let curOutputCurLang = null;
    let curOutputCurLangIndex = null;
    let curOutputDefLang = null;
    let curOutputDefLangIndex = null;
    //let langSelected = null;
    if (arg_outputs && arg_outputs.length > 0) {
      if (arg_streamindex !== null) {
        curOutput = arg_outputs[arg_streamindex].url;
        curOutputIndex = arg_streamindex;
      } else {
        for (let pt_items = 0; pt_items < arg_outputs.length; pt_items++) {
          let output_item = arg_outputs[pt_items];
          if (
            !curOutputCurLang
            &&
            arg_cul_lang
            &&
            output_item.lang == arg_cul_lang
          ) {
            curOutputCurLang = output_item;
            curOutputCurLangIndex = pt_items;
          }
          if (
            !curOutputDefLang
            &&
            arg_def_lang
            &&
            output_item.lang == arg_def_lang
          ) {
            curOutputDefLang = output_item;
            curOutputDefLangIndex = pt_items;
          }
        }
        if (curOutputCurLang) {
          curOutput = curOutputCurLang.url;
          curOutputIndex = curOutputCurLangIndex;
          //langSelected = arg_cul_lang;
        } else if (curOutputDefLang) {
          curOutput = curOutputDefLang.url;
          curOutputIndex = curOutputDefLangIndex;
          //langSelected = arg_def_lang;
        } else {
          curOutput = arg_outputs[0].url;
          curOutputIndex = 0;
          //langSelected = arg_outputs[0].lang
        }
      }
    } else {
      curOutput = null;
      curOutputIndex = null;
      //langSelected = null;
    }
    return curOutputIndex;
  },
  sendParentResizeEvent: function (arg_newWidth = null, arg_newHeight) {
    let _message = {
      "type": "resize",
      "content": {
        "newWidth": arg_newWidth,
        "newHeight": arg_newHeight,
      }
    };
    try {
      window.parent.postMessage(_message, '*');
    } catch (e) {
      //console.error(e);
    }
  },
  sendParentPlayerEvent: function (command) {
    let _message = {
      "type": 'command',
      "content": {
        command
      }
    };
    try {
      window.parent.postMessage(_message, '*');
    } catch (e) {
      //console.error(e);
    }
  },
}
